import React from "react";
import hearderbg from "../../Assest/new_logo_withshreebalaji.png";
import rightImage from "../../Assest/new_logo_withshreebalaji.png";

export default function ServiceDetails({ title, items, onBack }) {
    return (
        <div className="text-gray-800 overflow-hidden">

            {/* HERO */}
            <section
                className="relative py-28 bg-cover bg-center"
                style={{ backgroundImage: `url(${hearderbg})` }}
            >
                <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

                <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">
                        {title}
                    </h1>
                    <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
                        Powerful digital financial services designed for modern merchants.
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="relative py-24 bg-gray-50 overflow-hidden">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-stretch">

                    {/* LEFT SIDE */}
                    <div className="flex flex-col">

                        <button
                            onClick={onBack}
                            className="mb-6 text-indigo-600 font-semibold hover:underline"
                        >
                            ← Back to Services
                        </button>

                        {/* IMAGE WRAPPER */}
                        <div className="flex-1">
                            <img
                                src={rightImage}
                                alt="Service"
                                className="w-full h-full rounded-3xl shadow-2xl object-cover"
                            />
                        </div>

                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="space-y-8">
                        {items.map((item, index) => (
                            <div
                                key={index}
                                className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300"
                            >
                                <h3 className="text-xl font-semibold text-indigo-600 mb-2">
                                    {item.heading}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

        </div >
    );
}
